import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class planningRouteTasksListCtrl implements IController {

  internalTaskRouteTypes: any;

  constructor(private tasksConstants) {
    this.internalTaskRouteTypes = this.tasksConstants.internalTaskRouteTypes;
  }

  $onInit() {
  };

  $onChanges(changes) {
  };

  isStartEndRoute(purpose) {
    return _.includes(this.internalTaskRouteTypes, purpose);
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteTasksList', {
    bindings: {
      tasks: '<'
    },
    template: require('./planning-route-tasks-list.html').default,
    controller: planningRouteTasksListCtrl
  });
